import Vue from 'vue';
import CreateItem from './components/creator/create-item';
import CreateItemModal from './components/creator/create-item-modal';
import Reel from './components/user/reel';
import ReelItemModal from './components/user/ReelItemModal';
import VueSocialSharing from 'vue-social-sharing';
import ArtistPage from './components/creator/components/artist-page';
import vueLoader from './components/shared/vue-loader';
import ItemsList from './components/creator/items-list';
import CreatorItemModal from './components/creator/components/CreatorItemModal';
import CreateCriteria from './components/creator/monetization/create-criteria';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import Flix from './components/user/flix.vue';
import VueProgressBar from 'vue-progressbar';

import { createRouter, createWebHistory } from 'vue-router';

import SingleItem from './components/home/single-item';

// Vue.use(AudioPlayer)
Vue.use(VueSocialSharing);
import VuePlyr from 'vue-plyr';

Vue.use(VuePlyr);
import 'vue-plyr/dist/vue-plyr.css';
import ShakaTest from './components/shaka-test.vue';
import Comments from './components/comments.vue';
// import AlbumItemLike from "./components/user/albumss/album-item-like.vue";
import EditItem from './components/creator/edit-item.vue';
import Album from './components/user/album/album.vue';
// import AlbumDetails from "./components/user/album/album-details.vue";
import AlbumPage from './components/user/album/album-page.vue';
import VueTalk from './components/vue-talk.vue';
import StreamChat from './components/stream-chat.vue';
import LibraryPlaylist from './components/playlist/playlist-accordion.vue';
import Likes from './components/likes.vue';
import VueChatScroll from 'vue-chat-scroll';
import ShareIcon from './components/share-icons.vue';

// video Player Integration

import VideoPlayer from './components/videoPlayer/player.vue';

import ReelShorts from './components/shorts/index.vue';
import ReelsTags from './components/creator/flix-playlist/components/tags.vue';

import CreateFlixModal from './components/creator/create-flix-playlist-modal.vue';

import VideoCard from './components/creator/flix-playlist/video-card.vue';
import CreateFlixItem from './components/creator/flix-playlist/create/create-item.vue';
import MoreDetailItem from './components/creator/flix-playlist/flix-details/details.vue';
import TopPlaylist from './components/home/top-playlist.vue'

// pages

import FlixPlaylistPage from './pages/flix-playlist.vue';


Vue.use(VueChatScroll);
Vue.component('app-items-list', ItemsList);
Vue.component('app-creator-item-modal', CreatorItemModal);
Vue.component('app-create-item', CreateItem);
Vue.component('app-edit-item', EditItem);
Vue.component('app-create-item-modal', CreateItemModal);
Vue.component('app-reel', Reel);
Vue.component('app-reel-item-modal', ReelItemModal);
Vue.component('app-artist-page', ArtistPage);
Vue.component('app-scroll-loader', vueLoader);
Vue.component('app-create-criteria', CreateCriteria);
Vue.component('app-album', Album);
Vue.component('app-flix', Flix);
Vue.component('app-shaka-test', ShakaTest);
Vue.component('app-comments', Comments);
// Vue.component("app-album-item-like", AlbumItemLike);
// Vue.component("app-album-details", AlbumDetails);
Vue.component('app-album-page', AlbumPage);
// Vue.component("app-album", songs);
Vue.component('app-vue-talk', VueTalk);
Vue.component('app-stream-chat', StreamChat);

Vue.component('app-library-playlist', LibraryPlaylist);

Vue.component('app-likes', Likes);
Vue.component('app-share-icon', ShareIcon);

Vue.component('app-video-player', VideoPlayer);

Vue.component('app-reel-shorts', ReelShorts);

Vue.component('app-create-flix-playlist-modal', CreateFlixModal);
Vue.component('app-reel-tags', ReelsTags);
Vue.component('app-video-card', VideoCard);
Vue.component('app-more-detail-flix-item', MoreDetailItem);

Vue.component('app-create-flix-item', CreateFlixItem);
// page definitions

Vue.component('app-flix-playlist-page', FlixPlaylistPage);

Vue.component('app-single-item', SingleItem);
Vue.component('app-top-playlist',TopPlaylist);

// const routes = [
//   {
//     path: '/creator/flix-playlist/:id/create-item',
//     components: {
//       'CreateItem': CreateFlixItem,
//     },
//   },
// ];

window.Pusher = Pusher;

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  secure: process.env.MIX_PUSHER_APP_SCHEME === 'https',
  wsHost: window.location.hostname,
  wsPort: process.env.MIX_PUSHER_APP_PORT,
  wssPort: process.env.MIX_PUSHER_APP_PORT,
  forceTLS: process.env.MIX_PUSHER_APP_SCHEME === 'https',
  disableStats: false,
  enabledTransports: ['ws']
});

const options = {
  color: '#3b8de0',
  failedColor: '#D50055',
  thickness: '5px',
  autoRevert: true,
};

Vue.use(VueProgressBar, options);

// const router = createRouter({
//   history: createWebHistory(),
//   routes,
// });

const app = new Vue({
  el: '#app',
});
